<template>
    <el-card>
        <Headers slot="header"></Headers>
        <Content :getCartProducts="getCartProducts"></Content>
        <!--<Footer-->
            <!--:cartProducts="cartProducts"-->
            <!--:getCartProducts="getCartProducts"-->
        <!--&gt;</Footer>-->
    </el-card>
</template>
<script>
    // import Vue from 'vue';
    import Headers from '../components/GoodsSetup/Headers';
    import Content from '../components/GoodsSetup/Content';
    import {getCartProducts} from '../stores/api';

    // Vue.component('Header');
    // Vue.component('Content', GoodsSetup.Content);
    // Vue.component('Footer', GoodsSetup.Footer);

    export default {
        components:{
            Headers,
            Content
        },
        data () {
            return {
                cartProducts: [],
            };
        },
        beforeMount() {
            this.getCartProducts();
        },
        methods: {
            async getCartProducts() {
                getCartProducts().then(res => {
                    this.cartProducts = res.data.goods_list;
                });
            }
        },
    };
</script>

<style lang="less" scoped>
    /deep/ .el-card__header {
        padding: 10px 40px;
    }
    /deep/ .el-card__body {
        padding: 30px 40px;

    }
</style>



// WEBPACK FOOTER //
// src/router/GoodsSetup.vue